var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-box"},[_c('el-container',[_c('el-header',{staticClass:"header-box",attrs:{"height":"160px"}},[_c('Header')],1),_c('el-main',{staticClass:"el-main-box"},[_c('router-view')],1),_c('el-footer',{staticClass:"footer-box",attrs:{"height":"460px"}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }